import store from "../store"
import Button from "./components/button/button"
import ListItem from "./components/list_item/list_item"
import('./chart_list.css')

export default function ChartList(opts = {}){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let listItems = []
    let context = this
    let buttonAdd

    this.clearList = () =>{
        $(elements.listContainer).html("")//limpando html
        store.setCharts([])//limpando lista de gráficos
    }

    init()

    function init(){
        setStage()
        eventsHandler()
    }

    function setStage(){
        $(container).html('')
        // container do titulo
        elements.titleContainer = context.createElement('div', 'config-section-title mb-3', 'LISTA DE GRÁFICOS')
        
        //container da lista de gráficos
        elements.listContainer = document.createElement('div')
        $(elements.listContainer).addClass('chart-list-wrapper mb-2')

        //container dos botoões de ação
        elements.buttonsContainer = document.createElement('div')

        //adicionando botão para 'adicionar gráfico'
        buttonAdd = new Button({container: elements.buttonsContainer})


        buttonAdd.on('click', () =>{
            store.addChart()
        })

        //adicionanod estrutura no container principal
        $(container).append(elements.titleContainer, elements.listContainer, elements.buttonsContainer)
    }

    function eventsHandler(params) {
        //atualização completa da lista de gráficos
        store.subscribe('set_chart_list', data=>{
            setStage()
            store.getCharts().forEach(chart =>{
                generateListItem(chart.chart_name)
            })
        })

        store.subscribe('added_chart', chart_name=>{
            generateListItem(chart_name)
        })

        store.subscribe('chart-prop-updated', data =>{
            if(data.prop != 'chart_old_name'){
                data.chart.listItem.reload(data.chart.chart_old_name)
            }
            
        })
    }

    function generateListItem(chart_name){
        let chart_id = (Math.random() + 1).toString(36).substring(2);
        
        store.setChartPropByName(chart_name, 'chart_old_name', `${chart_name}_${chart_id}`)
        
        let listItem = new ListItem({chart_name: chart_name, chart_old_name: `${chart_name}_${chart_id}`})
        listItem.generate()

        store.setChartPropByName(chart_name, 'listItem', listItem)
        
        
        $(elements.listContainer).append(listItem.getElement())
    }
}

ChartList.prototype = Object.create(BaseConstructor.prototype)